import { render, staticRenderFns } from "./ViewAppsDetail.vue?vue&type=template&id=677a4ee2"
import script from "./ViewAppsDetail.vue?vue&type=script&lang=js"
export * from "./ViewAppsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports